import { appLocalStorage } from '@/app/shared/commonURLs';

let MilkBankUrl = appLocalStorage.NursePortalUrl;
let MilkBankODataUrl = appLocalStorage.NursePortalODataUrl;

export class uRls {
    constructor() {
        this.MilkBankServicesList = MilkBankURLs();

    }
}

const MilkBankURL = new uRls();

export { MilkBankURL };

function MilkBankURLs() {
    var services = {};

    services["GetVolumeUnits"] = {
        Method: 'GET',
        URL: MilkBankUrl + 'MilkUnit/GetVolumeUnits'
    };

    services["GetStorageStates"] = {
        Method: 'GET',
        URL: MilkBankUrl + 'MilkUnit/GetStorageStates'
    };

    services["GetFridges"] = {
        Method: 'GET',
        URL: MilkBankUrl + 'MilkUnit/GetFridges'
    };

    services["SaveMilkUnit"] = {
        Method: 'POST',
        URL: MilkBankUrl + 'MilkUnit/SaveMilkUnit'
    };

    services["GetMilkUnit"] = {
        Method: 'GET',
        URL: MilkBankUrl + 'MilkUnit/GetMilkUnit'
    };

    services["GetMilkUnitStatusDDL"] = {
        Method: 'GET',
        URL: MilkBankUrl + 'MilkUnit/GetMilkUnitStatusDDL'
    };

    services["GetMilkUnitDateType"] = {
        Method: 'GET',
        URL: MilkBankUrl + 'Configuration/GetMilkUnitDateType'
    };

    services["GetMilkUnitPrintModel"] = {
        Method: 'GET',
        URL: MilkBankUrl + 'MilkUnit/GetMilkUnitPrintModel'
    };

    services["DeleteMilkUnit"] = {
        Method: 'GET',
        URL: MilkBankUrl + 'MilkUnit/DeleteMilkUnit'
    }



    //
    //OData
    //
    services["MilkUnitOwnerOData"] = {
        Method: 'GET',
        URL: MilkBankODataUrl + 'MilkUnitOwnerOData?'
    }

    services["MilkUnitOData"] = {
        Method: 'GET',
        URL: MilkBankODataUrl + 'MilkUnitOData?'
    }

    return services
}





